<h2 mat-dialog-title>{{ message }}</h2>
<div mat-dialog-content class="dialog-content">
  @if (content) {
    <p>{{ content }}</p>
  }
  <form (submit)="submitForm()">
    @if (textarea) {
      <mat-form-field class="w-full">
        <mat-label>{{ placeholder | translate }}</mat-label>
        <textarea matInput rows="10" [required]="!optional" name="name" [formControl]="inputCtrl"></textarea>
        @if (hint) {
          <mat-hint>
            {{ hint }}
          </mat-hint>
        }
        @if (inputCtrl.hasError('required')) {
          <mat-error>
            {{ 'REQUIRED' | translate }}
          </mat-error>
        }
      </mat-form-field>
    }
    @if (!textarea) {
      <mat-form-field class="w-full">
        <mat-label>{{ placeholder }}</mat-label>
        <input matInput [required]="!optional" name="name" [formControl]="inputCtrl" />
        @if (hint) {
          <mat-hint>
            {{ hint }}
          </mat-hint>
        }
        @if (inputCtrl.hasError('required')) {
          <mat-error>
            {{ 'REQUIRED' | translate }}
          </mat-error>
        }
      </mat-form-field>
    }
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="submitForm()">
    {{ action || ('OK' | translate) }}
  </button>
  <button mat-raised-button (click)="dialogRef.close()">
    {{ 'CANCEL' | translate }}
  </button>
</div>
